const Form062SC = {
    form: "申請批准經營商業活動表格",
    stepName: {
        statement: "重要提示",
        basicInfor: "学校基本资料",
        partA: "商业活动的资料",
        partB: "其他详细资料及声明",
        confirmation: "确认",
    },
    errorMsg: {
        date: {
            afterThisDate: "请在 {{targetDate}} 之后选择日期",
        },
        float: {
            rule: "该字段必须是'数字'类型，最大小数点位数：2",
        },
    },
    businessTypes: {
        "Exercise books": "习作簿",
        "Stationery and school accessories": "文具及其他用品",
        Textbooks: "课本",
        "School uniforms, badges and ties": "校服校章及领带",
        "Physical education kits": "体育用品",
        "Lunch boxes": "饭盒",
        "School bus service": "校巴服务",
        "School Tuckshop": "食物部",
        Newspaper: "报纸",
        Others: "其他",
    },
    itemTypes: {
        "Exercise books": "(1)",
        "Stationery and school accessories": "(2)",
        Textbooks: "(3)",
        "School uniforms, badges and ties": "(4)",
        "Physical education kits": "(5)",
        "Lunch boxes": "(6)",
        "School bus service": "(7)",
        "School Tuckshop": "(8)",
        Newspaper: "(9)",
        Others: "(10)",
    },
    CSDOTypes: {
        "CW&S": "中西及南区",
        HKE: "东区",
        "WCH&I": "湾仔及离岛区",
        KC: "九龙城区",
        KT: "观塘区",
        SK: "西贡区",
        SSP: "深水埗区",
        WTS: "黄大仙区",
        YTM: "油尖旺区",
        N: "北区",
        ST: "沙田区",
        TP: "大埔区",
        "TW&KwT": "荃湾及葵青区",
        TM: "屯门区",
        YL: "元朗区",
    },
    label: {
        committees: "申请批准经营商业活动",
        business: "业务类别及供应商／承办商的姓名／名称",
        otherDetails: "其他详细资料",
        schoolName: "学校名称",
        schoolAddress: "学校地址",
        CSDO: "总学校发展主任",
        effectDate: "本校现申请由下列日期起经营/进行以下业务或商业活动/安排",
        businessType: "业务／商业活动／安排类别",
        supplierName: "供应商／承办商姓名／名称",

        approvalSubHeading: "校董会批准",
        referenceNo: "校董会批准档案编号",
        approvalDate: "校董会批准日期",

        // referenceNo: "校内档案编号",
        // approvalDate: "批准日期",
        // itemNo: "项目编号",
        itemNo: "业务／商业活动／安排类别",
        rental: "租金",
        utilitiesCharges: "杂费(例如：水、电、煤气)",
        commencementDate: "生效日期",
        terminationDate: "终止日期",
        documents: "证明文件(如有)",
        operationValue: "理由",
        HKD: "港币",
        specific: "请注明",
        statement: "声明（请在适当空格内加上“√”号）",
        statementTwo: "声明",
        certify: "本人已阅读及明白上述条款及细则。",
        rentalNote: "请视乎何者合适，注明按月或按年缴付的金额",
        utilitiesNote:
            "请注明由供应商／承办商按实际用量或按月／年以定额形式缴付／退还的金额",
        itemNoNote: "请采用与以上（A）部相同的项目编号。",
        agreement: "与供应商／承办商签订的经营合约",
        basicInfo: "学校基本资料",
    },
    statementValue: {
        statement1:
            "本人谨此确认，就经营／进行上述业务或商业活动／安排的申请，本校会遵照教育局现行有关「学校的商业活动」的通告内所载的规定，并确保以公开公平及透明的原则经营商业活动，并特此确认，所有由上述活动所得的利润或净收入将运用于能够使<u>本校学生直接受益</u>的用途上。",
        statement2:
            "就经营／进行上述业务或商业活动／安排的申请，本校的安排将有别于教育局现行有关「学校的商业活动」的通告内所载的规定，详情及原因如下－",
    },
    importantNotes: {
        note1: "请提交电子表格或纸质表格，请注意，如果提交了重复的申请，处理过程可能会受影响。",
        note2: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向有关高级学校发展主任提出。",
    },
    note: {
        note: "进入此网站前请先仔细阅读以下条款及细则。",
        noteList: [
            {
                text: "此申请批准经营商业活动的网上表格只适用于由校董会管理的学校。",
            },
            {
                text: "学校在填写此表格前请先参阅教育局现行有关学校的商业活动的通告。",
            },
            {
                text: "校监须使用「智方便+」数码签署作核准。",
            },
            {
                text: "请以电子表格或纸本表格提交申请。如重复递交申请，申请进度可能会受影响。",
            },
        ],
    },
};
export default Form062SC;
